import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Icon } from 'ui';
import PublicRoute from 'enums/publicRoutes';
import { StyledPageBreadcrumbs } from './style';

export interface PageBreadcrumb {
  id: number | string;
  name: string;
  path: string;
}

interface PageBreadcrumbsProps {
  crumbs: PageBreadcrumb[];
  backTo?: PageBreadcrumb;
  backLabel?: ReactNode;
  onBack: () => void;
  className?: string;
}

const PageBreadcrumbs = ({
  crumbs,
  backTo,
  backLabel,
  onBack,
  className,
}: PageBreadcrumbsProps) => {
  const intl = useIntl();

  return (
    <StyledPageBreadcrumbs className={className}>
      <Button
        className={'page-back'}
        icon={
          <span className={'page-back-icon'}>
            <Icon name={'arrow-circle-left'} type={'any'} />
          </span>
        }
        label={
          backLabel ||
          (backTo ? (
            <FormattedMessage
              id={'product_view.back_to_category'}
              values={{
                category: (
                  <strong className={'page-back-target'}>{backTo.name}</strong>
                ),
              }}
            />
          ) : (
            intl.formatMessage({ id: 'general.go_back' })
          ))
        }
        onClick={onBack}
      />
      {!!crumbs.length && (
        <nav className={'page-breadcrumbs'}>
          <Link to={PublicRoute.HOME}>
            {intl.formatMessage({ id: 'breadcrumbs.home' })}
          </Link>
          {crumbs.map((crumb) => (
            <span key={crumb.id} className={'page-breadcrumb'}>
              <span className={'page-breadcrumb-separator'} aria-hidden>
                <Icon name={'breadcrumb-chevron'} type={'any'} />
              </span>
              <Link to={crumb.path}>{crumb.name}</Link>
            </span>
          ))}
        </nav>
      )}
    </StyledPageBreadcrumbs>
  );
};

export default PageBreadcrumbs;
